import cypressIds from 'Components/cypress_ids.json';
import { VehicleInfoContextProvider } from 'Context/VehicleInfoContext';
import { applyCypressData } from 'Utilities/helpers';

import { BuyItNowCTA } from './BuyItNow/BuyItNowCTA';
import { ProxyCTA } from './SaleActive/ProxyCTA';
import { PostSaleCTA } from './Sold/PostSaleCTA';
import { useBiddingSection } from './useBiddingSection';
import type { UseBiddingViewName } from './useBiddingViewName';
import { useBiddingViewName } from './useBiddingViewName';

import styles from './BiddingSection.module.scss';

const DISALLOWED_STICKY_BIDDING_VIEW_NAMES: UseBiddingViewName[] = [
	null,
	'saleOverProcessing',
	'underOffer',
	'notYetForSale',
];

const ConditionalStickyBiddingView: React.FC<{ viewName: NonNullable<UseBiddingViewName> }> = ({ viewName }) => {
	if (viewName === 'saleActive') {
		return <ProxyCTA />;
	}

	if (viewName === 'buyItNow') {
		return <BuyItNowCTA />;
	}
	if (viewName === 'sold') {
		return <PostSaleCTA />;
	}

	return null;
};

export const StickyBiddingSection: React.FC = () => {
	const { hasDealershipWonVehicleAndSellerConfirmed, isOwnedByUserDealership } = useBiddingSection();
	const biddingViewName = useBiddingViewName();

	const shouldHideSoldCTA = biddingViewName === 'sold' && !hasDealershipWonVehicleAndSellerConfirmed;

	const shouldHideStickyBiddingSection =
		isOwnedByUserDealership ||
		DISALLOWED_STICKY_BIDDING_VIEW_NAMES.includes(biddingViewName) ||
		shouldHideSoldCTA ||
		!biddingViewName;

	if (shouldHideStickyBiddingSection) {
		return null;
	}

	return (
		<VehicleInfoContextProvider>
			<div className={styles.stickyFooter} {...applyCypressData(cypressIds.containers.stickyFooter)}>
				<ConditionalStickyBiddingView viewName={biddingViewName} />
			</div>
		</VehicleInfoContextProvider>
	);
};
